import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Button } from '@dojo/widgets/button';
import { Keys } from '@holmescorp/common';
import * as URI from 'uri-js';
import css from '../css/resource-parser.m.css';
import { includes } from 'lodash-es';
const factory = create({ theme }).properties();
export const ExternalLink = factory(({ children, properties, middleware: { theme } }) => {
    const { key, xqa, path, flags = [], isButton = false } = properties();
    const themeCss = theme.classes(css);
    const parsedURL = URI.parse(path);
    const isValidURL = !parsedURL['error'];
    const role = includes(flags, 'ariaRoleListitem') ? 'listitem button' : 'button';
    return isButton
        ? w(Button, {
            onClick: () => {
                if (isValidURL) {
                    window.open(path, '_blank');
                }
            }
        }, [children()])
        : v('span', {
            key,
            xqa,
            tabIndex: 0,
            role,
            classes: [themeCss.externallink],
            onclick: (event) => {
                event.stopPropagation();
                if (isValidURL) {
                    window.open(path, '_blank');
                }
            },
            onkeydown: (event) => {
                switch (event.key) {
                    case Keys.Enter:
                    case Keys.Space:
                    case Keys.Spacebar:
                        event.preventDefault();
                        if (isValidURL) {
                            window.open(path, '_blank');
                        }
                }
            }
        }, children());
});
